import logo from "../assets/logo.png";

const Finish = () => {
	return (
		<div className="content full-page flex-column bg-white">
			<img src={logo} alt="logo" className="qr-logo" />
			<h1 className="finish-title title-md text-medium-inter">Thank you!</h1>
			<p className="align-center text-sm mb-0">
				To know more about Condopal, please visit
			</p>
			<a href="https://mycondopal.com" className="text-dark text-sm">
				https://mycondopal.com
			</a>
		</div>
	);
};

export default Finish;
